import { Input } from './input';
import { Label } from './input-label';
import { Limit } from './input-limit';
import { withAliases } from '../../../ui/utils/with-aliases';
var InputComponent = withAliases(Input, { Label: Label, Limit: Limit });
export { InputComponent as Input };
